'use strict'

const list = [
	'article-edit-button',
	'article-new-button',
	'category',
	'category-hlasludu',
	'category-hlasludu-personal',
	'category-hlasludu-personal-detail-closed',
	'category-hlasludu-personal-detail-open',
	'club-search',
	'club-detail',
	'competition-matches',
	'competition-schedule',
	'competition-selector',
	'competition-table',
	'detail',
	'detail-title',
	'event-calendar',
	'event-detail',
	'event-list',
	'event-list-szts',
	'file-list',
	'file-list-without-date',
	'image',
	'image-rotator',
	'join-us',
	'gallery',
	'hall-of-fame',
	'html-table',
	'iframe',
	'live-center',
	'match-events',
	'match-highlight',
	'match-players',
	'menu',
	'menu-zosr',
	'person-search',
	'pure-html',
	'roster-detail',
	'roster-detail-svf',
	'roster-detail-svf-digital',
	'roster-detail-szpz',
	'roster-list-szpz',
	'rosters',
	'contracts',
	'showcase',
	'public-registration-with-payment',
	'join-us-v2',
	'join-us-tkl',
	'login',
	'login-tkl',
	'test',
	'list-members',
	'list-members-tkl',
	'member-detail',
	'member-detail-personal',
	'member-detail-personal-tkl',
	'discussion',
	'user-task-detail',
	'voting-category',
	'voting-field',
	'voting',
	'time-countdown',
	'discussion-replies',
	'password-change',
	'password-forgotten',
	'password-reset',
	'registration-form-zosr',
	'voting-delegation-user',
	'voting-delegated-votes-user',
	'voting-delegated-votes-delegate',
	'offering-list',
	'offering-detail',
	'school-list',
	'school-detail',
	'couples-detail',
	'couples-search',
	'menu-2',
	'image-for-grid-sgf',
	'event-list-sgf',
	'image-for-button-widget-szts',
	'image-for-image-widget-szts',
	'event-list-sgf',
	'coach-search-szts',
	'booking-wellness',
	'booking-courts',
	'booking-conference',
	'booking-list-tkl',
	'venues',
	'admin-control-panel-tkl',
]

let config = {
	base: require('./base.edit')
}
list.forEach(name => {
	config[name] = require('./' + name + '/' + name + '.edit')
})

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./src/widgets/_index.js
// module id = 271
// module chunks = 0